export default __webpack_public_path__ + "static/media/office1-after1-1920w.25d00b98.webp";